<script setup>
  import { ref, watch, defineExpose, defineProps, defineEmits } from 'vue'

  const props = defineProps({
    visible: {
      type: Boolean,
      default: false,
    },
  })

  const emit = defineEmits(['update:visible'])
  const visible = ref(props.visible)

  watch(
    () => props.visible,
    value => {
      visible.value = value
    }
  )

  const show = () => {
    visible.value = true
    emit('update:visible', true)
  }

  const hide = () => {
    visible.value = false
    emit('update:visible', false)
  }

  defineExpose({
    show,
    hide,
  })
</script>

<template>
  <div class="loading" :class="{ show: visible }">
    <div class="loader"></div>
  </div>
</template>

<style lang="less" scoped>
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    transition: opacity 0.5s;
    opacity: 0;
    pointer-events: none;

    &.show {
      opacity: 1;
      pointer-events: auto;
    }
  }

  // デザイン変えたかったらココを利用してください
  // https://css-loaders.com/spinner/

  .loader {
    width: 50px;
    aspect-ratio: 1;
    display: grid;
    border: 4px solid #0000;
    border-radius: 50%;
    border-right-color: #25b09b;
    animation: l15 1s infinite linear;
  }

  .loader::before,
  .loader::after {
    content: '';
    grid-area: 1/1;
    margin: 2px;
    border: inherit;
    border-radius: 50%;
    animation: l15 2s infinite;
  }

  .loader::after {
    margin: 8px;
    animation-duration: 3s;
  }

  @keyframes l15 {
    100% {
      transform: rotate(1turn);
    }
  }
</style>
